import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';


import SoliteraLogo from '../../../assets/organizations/solitera.png';
import OrganizationProps from '../../model/organization-props';

export default function Organizations(props: OrganizationProps){
    return (
        <Container sx={{ marginTop: !props.isMobile ? '8em' : '0', paddingTop: !props.isMobile ? '0em' : '4em', height: !props.isMobile ? '0em' : '89vh'}}>
            <Typography component='h2' variant='h6' color='#fff' fontWeight='medium' sx={{ marginBottom: 4 }}>
                Organizations
            </Typography>
            <Grid  mb={10} container spacing={0} justifyContent={"center"} alignItems={"center"}>
                <Grid item> 
                    <img src={SoliteraLogo} alt='Solitera Software Logo' height={168.75 / 1.5} width={300/1.5} />
                </Grid>
            </Grid>
        </Container>
    );
}